<section *transloco="let t" class="relative py-12 sm:py-24">
  <!-- Full-bleed Accent Background -->
  <div class="absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2 bg-accent-500"></div>

  <!-- Title & Subtitle -->
  <div class="mx-auto max-w-3xl text-center">
    <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
      {{ t('home.exploreThemes.title') }}
    </h2>
    <p class="mt-4 text-base text-white/90 sm:text-xl">
      {{ t('home.exploreThemes.subtitle') }}
    </p>
  </div>

  <!-- Themes -->
  <div class="mt-10 grid gap-5 sm:mt-12 sm:grid-cols-2 sm:gap-8">
    @for (theme of themes; track theme.key) {
      <div class="flex flex-col rounded-2xl bg-white p-3 shadow-lg sm:rounded-3xl sm:p-5">
        <!-- Theme Image -->
        <img
          [src]="theme.image"
          alt=""
          class="aspect-[16/10] w-full rounded-xl object-cover sm:rounded-2xl"
        />

        <!-- Theme Title -->
        <h3 class="pt-4 pb-1 text-center text-lg font-semibold text-slate-800 sm:pt-5 sm:text-2xl">
          {{ t('home.exploreThemes.themes.' + theme.key + '.title') }}
        </h3>
      </div>
    }
  </div>
</section>
